"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Check if two numbers are within 1/10^decimal of each other.
 *
 * @function areNumbersEqualToDecimal
 * @param a - Number
 * @param b - Number
 * @param decimal - number of decimal places to which to round before compar
 * @returns number based on input string
 */
var areNumbersEqualToDecimal = function areNumbersEqualToDecimal(a, b) {
  var decimal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return Math.abs(a - b) < Math.pow(10, -decimal);
};

var _default = areNumbersEqualToDecimal;
exports["default"] = _default;